module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-rack-10d627fb.svg";